import { BaseGQLService } from '../../common/services/BaseGQLService';
import { ModelType } from '../../common/utils/GQLIdEncoder';
import { ReportMapper } from '../mappers/ReportMapper';
import { Report } from '../models/Report';

export const GET_UPLOAD_FORM_DATA = `
mutation {
  generateTraceUploadPost(input: {}) {
    url
    formData
    method
  }
}
`;

export const CREATE_REPORT_QUERY = `
mutation($projectId: ID!, $slotId: ID!, $name: String!, $key: String!, $size: BigInt!, $generateReport: Boolean) {
  createTrace(
    input: {
      projectId: $projectId,
      slotId: $slotId,
      fileName: $name,
      key: $key,
      size: $size,
      generateReport: $generateReport
    }
  ) {
    report {
      id
      name
      trace {
        id
        name
      }
    }
  }
}
`;

interface FormData {
  url: string;
  method: 'PUT' | 'POST';
}

interface PostFormData extends FormData {
  method: 'POST';
  formData: {
    key: string;
    policy: string;
    'x-amz-signature': string;
    'x-amz-date': string;
    'x-amz-algorithm': string;
    'x-amz-credential': string;
    success_action_status: number;
    acl: string;
  };
}

interface PutFormData extends FormData {
  method: 'PUT';
  formData: {
    key: string;
  };
}

export type TraceUploadFormData = PostFormData | PutFormData;

export class ReportService extends BaseGQLService {
  private readonly mapper = new ReportMapper();

  async getUploadFormData(): Promise<TraceUploadFormData> {
    return this.mutate(GET_UPLOAD_FORM_DATA, {}, (data) => {
      const {
        generateTraceUploadPost: { url, method, formData },
      } = data;
      return {
        url,
        method,
        formData: JSON.parse(formData),
      };
    });
  }

  async createReport(projectId: number, slotId: number, name: string, key: string, size: number): Promise<Report> {
    return this.mutate(
      CREATE_REPORT_QUERY,
      {
        projectId: this.gqlIdEncoder.encode(ModelType.Project, projectId),
        slotId: this.gqlIdEncoder.encode(ModelType.Slot, slotId),
        name,
        key,
        size,
        generateReport: true,
      },
      (data) => this.mapper.mapGQLModel(data.createTrace.report)
    );
  }
}
